import { NextResponse } from "next/server";
import axios from "axios";

export async function POST(req) {
  try {    
    const { accessToken, part = "statistics" } = await req.json();    

    const response = await axios.get("https://www.googleapis.com/youtube/v3/channels",{
        params: {
            part,
            mine: true,
        },
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return NextResponse.json({ data: response.data });
  } catch (error) {
    console.error("Error during getting youtube data:", error.response ? error.response.data : error.message);
    return NextResponse.json(
      { error: "Youtube data retrieve failed", details: error.response ? error.response.data : error.message },
      { status: 500 }
    );
  }
}
